export enum AttributeUiType {
  ShortAnswer = 'ShortAnswer',
  LongAnswer = 'LongAnswer',
  Number = 'Number',
  Date = 'Date',
  Toggle = 'Toggle',
  DropDown = 'DropDown',
  RadioButtonGroup = 'RadioButtonGroup',
  Checkboxes = 'Checkboxes',
  MultiSelect = 'MultiSelect',
  Skill = 'Skill',
  StarRating = 'StarRating',
  Document = 'Document',
  DateRange = 'DateRange',
  Complex = 'Complex',
  EncryptedField = 'EncryptedField',
  CalculatedField = 'CalculatedField'
}
